function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 3.42183L7.71875 6.70308C7.32827 7.09356 6.69517 7.09356 6.30469 6.70308C5.91421 6.3126 5.91421 5.6795 6.30469 5.28902L11.2219 0.371803C11.4052 0.145021 11.6857 0 12 0C12.3033 0 12.5751 0.135049 12.7585 0.348299L17.7051 5.29488C18.0956 5.68536 18.0956 6.31846 17.7051 6.70894C17.3146 7.09942 16.6815 7.09942 16.291 6.70894L13 3.41792V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V3.42183ZM0 18C0 14.6863 2.68629 12 6 12H7C7.55228 12 8 12.4477 8 13C8 13.5523 7.55228 14 7 14H6C3.79086 14 2 15.7909 2 18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14H17C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12H18C21.3137 12 24 14.6863 24 18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18Z",
  fill: "#B7BFCA"
});

var SvgBorrow = function SvgBorrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBorrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/borrow.b9fc2618.svg";
export { ForwardRef as ReactComponent };